import { type CellContext } from '@tanstack/react-table';
import { QuotesCodeMapping } from '@/constants/quote/quote';
import CountriesIcons from '@/components/atoms/CountriesIcons/CountriesIcons';
import Link from 'next/link';
import { generateStockLinkBySymbol } from '@/utils/links';

type DFormat = {
  [QuotesCodeMapping.SYMBOL]: string;
  [QuotesCodeMapping.TRADE_TIME]: number;
  [QuotesCodeMapping.CHINESE_NAME]: string;
  [QuotesCodeMapping.ENGLISH_NAME]: string;
  [QuotesCodeMapping.BID]: string;
  [QuotesCodeMapping.ASK]: string;
  [QuotesCodeMapping.CHANGE_PERCENT_V2]: string;
  [QuotesCodeMapping.CHANGE_V2]: string;
};

export const countrySymbolName = {
  header: () => <div className='text-left'>名稱</div>,
  accessorKey: QuotesCodeMapping.CHINESE_NAME.toString(),
  cell: (props: CellContext<DFormat, string>) => {
    const englishName = props?.row?.original?.[QuotesCodeMapping.ENGLISH_NAME];
    const symbol = props?.row?.original?.[QuotesCodeMapping.SYMBOL];
    const link = generateStockLinkBySymbol(symbol);

    return (
      <div className='flex items-center'>
        {englishName?.includes('/') && <CountriesIcons countries={englishName.split('/')} />}
        <div className='ml-[6px] text-left '>
          <a className='font-semibold leading-[14px] text-[#383838]' href={link}>
            {props.getValue()}
          </a>
          <p className='mt-[6px] text-xs leading-3 text-[#848d97]'>{englishName}</p>
        </div>
      </div>
    );
  }
};
